module.exports = __webpack_public_path__ + "img/card_comunicacion.6f7c436f.jpg";